<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div id="compos">
    <template v-if="actualViewAction === 'loading'">
      <b-loading
        is-full-page
        :active.sync="isLoading"
      >
        <div class="box loading">
          <div class="bloader">
            <div class="shape shape-1" />
            <div class="shape shape-2" />
            <div class="shape shape-3" />
            <div class="shape shape-4" />
          </div>
        </div>
      </b-loading>
    </template>
    <div
      v-if="actualViewAction === 'action'"
      id="page_give_poll"
      class="container"
    >
      <!-- <Ad5Compo
        v-if="renderComponent"
      /> -->
      <!-- <div id="ad_action_1" /> -->

      <div class="box progressbar">
        <h3 id="hi_quiz_name">
          <span class="quiz_name">
            {{ $t('index.quiz', { name: quizData.name }) }}
          </span>
        </h3>
        <div class="progressbar_container">
          <span class="main_progress_text">
            <span class="main_progress_number">
              {{ humanCount }}
            </span>/<span id="questions_max">
              10
            </span>
          </span>
          <div class="progress-bar-wrap">
            <div
              class="progress-bar"
              role="progressbar"
              :style="{ width: percentage + '%' }"
            />
          </div>
        </div>
      </div>

      <!-- 728x90/320x50 waldo-tag-15165 -->
      <div id="ad-quiz-top" style="margin-bottom: 5px" />

      <div
        :id="'question_block_id_' + (currentCount + 1)"
        class="box question_block"
      >
        <div
          id="question"
          class="question_bg"
          :style="{ backgroundColor: colorMatchs[quizData.questions[currentCount].color] }"
        >
          {{ currentQuestion }}
        </div>

        <div
          v-for="(option, optionIndex ) in currentOptions"
          :id="'option_enclosure_' + (optionIndex + 1)"
          :key="option.id"
          :class="[{ disabled: disableButtons, answered_right: answeredRight === optionIndex, answered_wrong: answeredWrong === optionIndex }, 'option_bg option_' + (optionIndex + 1) +'_bg']"
        >
          <span
            :id="'option_' + (optionIndex + 1)"
            class="option_text"
            @click="option_clicked(optionIndex+1)"
          >
            {{ option }}
          </span>
        </div>

        <div class="notice_text_container">
          <i class="fas fa-fingerprint" /><span
            id="give_page_note"
            class="notice_text"
          >
            {{ $t('quiz.tap') }}
          </span>
        </div>
      </div>

      <!-- 300x250 -->
      <!-- <div id="waldo-tag-15168" /> -->

      <!-- <div id="ad_action_2" /> -->
    </div>
    <ResultCompo
      v-if="actualViewAction === 'result'"
      :score="score"
      :friend-name="friendName"
      :quiz-data="quizData"
    />
    <ChartCompo
      v-if="actualViewAction === 'result'"
      :quiz-data="quizData"
    />
    <!-- <Ad2Compo
      v-if="actualViewAction === 'action'"
    /> -->
    <!-- <Ad3Compo
      v-if="actualViewAction === 'result'"
    /> -->
    <!-- <InstaCompo
      v-if="actualViewAction === 'result'"
    /> -->
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import { colorOptions, colorMatchs } from '@/consts'
import ResultCompo from '@/components/ResultCompo.vue'
import ChartCompo from '@/components/ChartCompo.vue'
// import Ad2Compo from '@/components/Ad2Compo.vue'
// import Ad5Compo from '@/components/Ad5Compo.vue'
// import InstaCompo from '@/components/InstaCompo.vue'
// import Ad3Compo from '@/components/Ad3Compo.vue'

export default {
  name: 'RegisterCompo',
  components: {
    ResultCompo,
    ChartCompo
    // Ad2Compo,
    // Ad5Compo,
    // InstaCompo,
    // Ad3Compo
  },
  // eslint-disable-next-line
  props: [ 'quizData', 'friendName', 'qId', 'userId', 'newUser' ],
  data () {
    return {
      colorOptions: colorOptions,
      colorMatchs: colorMatchs,
      actualViewAction: 'action',
      currentCount: 0,
      score: 0,
      answersArray: [],
      answeredRight: '',
      answeredWrong: '',
      disableButtons: false,
      isLoading: false
      // playwireUnits: [
      //   // {
      //   //   selectorId: 'ad_action_1',
      //   //   type: 'leaderboard_atf'
      //   // },
      //   {
      //     selectorId: 'ad_action_2',
      //     type: 'med_rect_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ],
      // tyched: false
    }
  },
  computed: {
    currentQuestion () {
      return this.quizData.questions[this.currentCount].question
    },
    currentOptions () {
      return this.quizData.questions[this.currentCount].options
    },
    humanCount () {
      return this.currentCount + 1
    },
    percentage () {
      return this.currentCount * 10
    }
  },
  mounted () {
  // // As an instance method inside a component
  //   this.$loadScript('//cdn.thisiswaldo.com/static/js/15148.js')
  //     .then(() => {
  //       // Script is loaded, do something
    // waldo.refreshTag('waldo-tag-15165')
    // waldo.refreshTag('waldo-tag-15168')
  //     })
  //     .catch(() => {
  //       // Failed to fetch script
  //     })
    // if (this.actualViewAction === 'action' && !this.tyched) {
    //   this.initTyche()
    //   this.tyched = true
    // }
  },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API@Action is initialized')
    //   try {
    //     ramp.destroyUnits('all')
    //   } catch (e) {
    //     console.log('destroyUnits error: ', e)
    //   }
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    isPair (number) {
      return (number % 2) === 1
    },
    option_clicked (number) {
      if ((number - 1) === this.quizData.questions[this.currentCount].answer) {
        this.score++
        this.answeredRight = number - 1
      } else {
        this.answeredRight = this.quizData.questions[this.currentCount].answer
        this.answeredWrong = number - 1
      }
      // console.log(this.score)
      // if (this.currentCount == 1) {
      //   waldo.refreshTag('waldo-tag-15165')
      //   waldo.refreshTag('waldo-tag-15168')
      // }
      // if (this.currentCount == 4) {
      //   waldo.refreshTag('waldo-tag-15165')
      //   waldo.refreshTag('waldo-tag-15168')
      // }
      // if (this.currentCount == 6) {
      //   waldo.refreshTag('waldo-tag-15165')
      //   waldo.refreshTag('waldo-tag-15168')
      // }
      if (this.currentCount <= 8) {
        this.disableButtons = true
        if (!this.isPair(this.currentCount)) {
          // this.initTyche()
        }
        // this.forceRerender()
        setTimeout(() => {
          // window.scrollTo(0, 117)
          this.disableButtons = false
          this.currentCount++
          this.answersArray.push(number)
          document.body.style.backgroundColor = colorOptions[this.quizData.questions[this.currentCount].color]
          this.answeredRight = ''
          this.answeredWrong = ''
        }, 1000)
      } else {
        this.disableButtons = true
        setTimeout(() => {
          window.scrollTo(0, 0)
          this.disableButtons = false
          document.body.style.backgroundColor = '#242933'
          this.answersArray.push(number)
          this.actualViewAction = 'loading'
          this.isLoading = true
          if (this.newUser) {
            const toQuizzes = {
              answerers: {
                uid: this.userId,
                name: this.friendName,
                score: this.score
              }
            }
            const createUser = {
              uid: this.userId,
              quizes_given: {
                qid: this.qId,
                status: this.answersArray
              }
            }
            this.$http.all([
              this.$http.patch('https://bestiebackend.herokuapp.com/api/quizzes/' + this.qId, toQuizzes),
              this.$http.post('https://bestiebackend.herokuapp.com/api/users/', createUser)
            ])
              .then(response => {
                this.quizData = response[0].data.quiz
                this.actualViewAction = 'result'
                this.isLoading = false
              })
              .catch(error => {
                // console.log(error)
              })
          } else {
            const toQuizzes = {
              answerers: {
                uid: this.userId,
                name: this.friendName,
                score: this.score
              }
            }
            const toUsers = {
              quizes_given: {
                qid: this.qId,
                status: this.answersArray
              }
            }
            this.$http.all([
              this.$http.patch('https://bestiebackend.herokuapp.com/api/quizzes/' + this.qId, toQuizzes),
              this.$http.patch('https://bestiebackend.herokuapp.com/api/users/' + this.userId, toUsers)
            ])
              .then(response => {
                this.quizData = response[0].data.quiz
                this.actualViewAction = 'result'
                this.isLoading = false
              })
              .catch(error => {
                // console.log(error)
              })
          }
        }, 1000)
      }
    }
  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
